<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout pt-3 wrap justify-start>
      <v-flex xs5 sm3 md3 lg2 xl2>
        <v-layout wrap justify-center>
          <v-flex xs3 sm2 text-left align-self-center>
            <v-img
              src="./../../../assets/Images/agogo.png"
              contain
              height="30px"
            ></v-img>
          </v-flex>
          <v-flex xs9 sm8 text-left pl-2 align-self-center>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 18px;
                color: #1c1c1c;
              "
            >
              Add Offer
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout pt-0 wrap justify-center>
          <!-- <v-flex xs12 pa-1>
            <v-img :src="mediaURL + pic" height="200px" contain>
              <v-layout wrap>
                <v-flex text-right pa-0>
                  <v-avatar color="#FF3434" size="15">
                    <v-icon color="#FFF" small @click="removePhoto(i, item)">
                      mdi-close
                    </v-icon>
                  </v-avatar>
                </v-flex>
              </v-layout>
            </v-img>
          </v-flex> -->
          <v-flex xs12 v-for="(item, i) in imageArray" :key="i" pa-1>
            <!-- <v-img :src="item" height="85px" contain>
              <v-layout wrap>
                <v-flex text-right pa-0>
                  <v-avatar color="#FF3434" size="15">
                    <v-icon color="#FFF" small @click="removeImageArray(i)">
                      mdi-close
                    </v-icon>
                  </v-avatar>
                </v-flex>
              </v-layout>
            </v-img> -->
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12>
            <v-layout wrap justify-center>
              <v-flex pt-4 xs12 text-left>
                <v-layout wrap justify-center>
                  <v-flex xs8 sm6 md6 lg8>
                    <v-card flat tile outlined height="300px">
                      <v-layout wrap justify-center fill-height>
                        <v-flex md12 lg12 align-self-center>
                          <v-img
                            v-if="imageArray[0]"
                            :src="imageArray[0]"
                            height="298px"
                            contain
                          >
                            <v-layout wrap>
                              <v-flex text-right pa-2>
                                <v-avatar color="#FF3434" size="20">
                                  <v-icon
                                    color="#FFF"
                                    small
                                    @click="removeImageArray(0)"
                                  >
                                    mdi-close
                                  </v-icon>
                                </v-avatar>
                              </v-flex>
                            </v-layout>
                          </v-img>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <!-- <v-flex xs4 sm3 md3 lg4>
                <v-layout pt-0 wrap justify-center>
                  <v-flex xs12 v-for="(item, i) in imageArray" :key="i" pa-1>
                    <v-img v-if="i > 0" :src="item" height="85px" contain>
                      <v-layout wrap>
                        <v-flex text-right pa-0>
                          <v-avatar color="#FF3434" size="15">
                            <v-icon
                              color="#FFF"
                              small
                              @click="removeImageArray(i)"
                            >
                              mdi-close
                            </v-icon>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-img>
                  </v-flex>
                </v-layout>
              </v-flex> -->
                </v-layout>
              </v-flex>
              <v-flex xs12 sm9 md9 lg12 pt-4 text-center>
                <v-btn
                  width="180px"
                  small
                  tile
                  depressed
                  :ripple="false"
                  class="text-capitalize"
                  color="#EFEFEF"
                  @click="$refs.files.click()"
                >
                  <v-layout wrap justify-center>
                    <v-flex xs8 text-right>
                      <span
                        style="font-size: 12px; font-family: opensanssemibold"
                      >
                        Upload Image
                      </span>
                    </v-flex>
                    <v-flex xs4 text-right>
                      <v-img
                        src="./../../../assets/icons/file-upload.svg"
                        height="15px"
                        contain
                      ></v-img>
                    </v-flex>
                  </v-layout>
                </v-btn>
                <input
                  v-show="false"
                  accept="image/*"
                  id="file"
                  ref="files"
                  multiple="multiple"
                  type="file"
                  @change="uploadImages"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex md9>
        <v-form ref="form">
          <v-layout wrap pa-3 justify-center>
            <v-flex xs6 text-left pr-1>
              <v-text-field
                :rules="[rules.required]"
                v-model="name"
                prepend-icon="mdi-account"
                label="Offer Name"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs6 text-left pl-1>
              <v-text-field
                :rules="[rules.required]"
                v-model="description"
                prepend-icon="mdi-pencil"
                label="Offer Description"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs6 pr-1>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="date"
                    label="Starting date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :min="today" v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 pl-1>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date2"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="date2"
                    label="Ending date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :min="today"  v-model="date2" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal2 = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu2.save(date2)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 pr-1>
              <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="time"
                    label="Starting time"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu3"
                  v-model="time"
                  full-width
                  @click:minute="$refs.menu3.save(time)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 pr-1>
              <v-menu
                ref="menu4"
                v-model="menu4"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time2"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    v-model="time2"
                    label="Ending time"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu4"
                  v-model="time2"
                  full-width
                  @click:minute="$refs.menu4.save(time2)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6>
              <v-select
                :rules="[rules.required]"
                v-model="selectValue"
                :items="selectItems"
                label="Select Item"
                multiple
              >
              </v-select>
            </v-flex>

            <v-flex xs12 py-3 v-if="$route.query.id">
              <v-btn
                width="300px"
                dense
                dark
                tile
                color="red"
                @click="EditOffer"
              >
                Edit
              </v-btn>
            </v-flex>
            <v-flex v-else xs12 py-3>
              <v-btn
                width="300px"
                dense
                dark
                tile
                color="red"
                @click="addOffer"
              >
                save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="cropImageDialog"
      persistent
      :width="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? '100vw'
          : $vuetify.breakpoint.name == 'md'
          ? '80vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '50vw'
          : '40vw'
      "
    >
      <v-card>
        <v-layout wrap justify-center pa-2>
          <v-flex xs12>
            <ImageCropper
              :image="currentImage"
              :key="currentImage"
              @stepper="imageCropper"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import Propic from "./profileImage.vue";
import ImageCropper from "./../../Common/imageCropper.vue";
import axios from "axios";
import moment from "moment";
export default {
  components: {
    // PriceDistro,
    ImageCropper,
  },
  data() {
    return {
      ID: null,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      pic: null,
      timeout: 3000,
      selectedFiles: null,
      name: null,
      description: null,
      showSnackBar: false,
      msg: "",
      imageArray: [],
      currentImage: null,
      cropImageDialog: false,
      coverImage: null,
      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu2: false,
      menu3: false,
      menu4: false,
      modal2: false,
      time: null,
      time2: null,
      selectItems: [],
      selectValue: null,
      Images: new FormData(),
      formData: new FormData(),
      // cropImageDialog: false,
    };
  },
  mounted() {
    this.getCity();
    if (this.$route.query.id) {
      this.getData();
    }
  },
  methods: {
    DateFormatted(params) {
      return params ? moment(params).format("YYYY-MM-DD") : "";
    },
    TimeFormatted(params) {
      return params ? moment(params).format("hh:mm A") : "";
    },
    getData() {
      axios({
        method: "get",
        url: "seller/offer/view/" + this.$route.query.id,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.Images,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.name = response.data.data.name;
            this.description = response.data.data.description;
            this.date = this.DateFormatted(response.data.data.starting);
            this.date2 = this.DateFormatted(response.data.data.ending);
            this.time = this.TimeFormatted(response.data.data.starting);
            this.time2 = this.TimeFormatted(response.data.data.ending);
            this.selectValue = response.data.data.cities;
            if(response.data.data.photo != null)
            {
            this.pic = response.data.data.photo;
            this.imageArray.push(this.mediaURL + this.pic);
            }
          } else {
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadPhoto() {
      axios({
        method: "post",
        url: "seller/offer/edit/" + this.ID,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.Images,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.msg = response.data.msg;
            this.$router.push("/Seller/Offers");
          } else {
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addOffer() {
      if (this.$refs.form.validate()) {
        axios({
          method: "post",
          url: "seller/offer/add",
          data: {
            name: this.name,
            description: this.description,
            startingDate: this.date,
            endingDate: this.date2,
            startingTime: this.time,
            endingTime: this.time2,
            cities: this.selectValue,
          },
          headers: {
            token: localStorage.getItem("token"),
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              this.showSnackBar = true;
              this.msg = response.data.msg;
              this.ID = response.data.oId;
              if (this.ID != null && this.selectedFiles != null)
                this.uploadPhoto();
              else {
                this.$router.push("/Seller/Offers");
              }
            } else {
              this.showSnackBar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
      EditOffer() {
      if (this.$refs.form.validate()) {
        axios({
          method: "post",
          url: "seller/offer/edit/" + this.$route.query.id,
          data: {
            name: this.name,
            description: this.description,
            startingDate: this.date,
            endingDate: this.date2,
            startingTime: this.time,
            endingTime: this.time2,
            cities: this.selectValue,
          },
          headers: {
            token: localStorage.getItem("token"),
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              this.showSnackBar = true;
              this.msg = response.data.msg;
              this.ID = response.data.oId;
                this.editPhoto();
              
            } else {
              this.showSnackBar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },
      editPhoto() {
      axios({
        method: "post",
        url: "seller/offer/edit/" + this.$route.query.id,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.Images,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.msg = response.data.msg;
            this.$router.push("/Seller/Offers");
          } else {
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getCity() {
      axios({
        method: "get",
        url: "sellers/city/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.selectItems = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    removeImageArray(i) {
      var values = this.formData.getAll("photos");
      values.splice(i, 1);
      this.formData.set("photos", values);
      this.imageArray.splice(i, 1);
    },
    imageCropper(payload) {
      this.cropImageDialog = payload.dialog;
      if (payload.image) {
        this.collectImages(payload.image);
      }
    },
    profilewinStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImage = window_data.selectedFiles;
        this.profileImageUpload();
      }
    },
    collectImages(image) {
      this.selectedFiles = image;
      console.log("this", this.selectedFiles);
      this.Images.append("photo", this.selectedFiles);
      // console.log("this.selectedfiles",this.selectedFiles)
      // this.formData.append("photos", this.selectedFiles);
      this.pic = this.selectedFiles;
      console.log(this.pic, "jjjjj");
      // console.log(this.formData,'ggggg')
      var img = new Image();
      img.src = window.URL.createObjectURL(image);
      img.onload = () => {
        const urls = URL.createObjectURL(image);
        this.imageArray.push(urls);

        if (this.imageArray) {
          this.image = this.imageArray[0];
        }
      };
    },
    uploadImages(event) {
      if (this.imageArray.length < 1) {
        this.currentImage = URL.createObjectURL(event.target.files[0]);
        console.log("propic", this.currentImage);
        this.cropImageDialog = true;
      } else {
        this.msg = "Maximum image limit exceeded!";
        this.showSnackBar = true;
        return;
      }
    },
  },
};
</script>